import { CircularProgress } from '@mui/material'
import React from 'react'

const Loading = () => {
  return (
    <CircularProgress color="inherit" />
  )
}

export default Loading